<rask-kontrakt-checklist></rask-kontrakt-checklist>
<rask-kontrakt-header [entity]="entity()"></rask-kontrakt-header>

@if (kontrakt.hasAffarsform) {
  <rask-kontrakt-forkalkyl
    *raskPermitted="[{ role: 'RASK.Kopplanera', canView: false }]; merge: true">
  </rask-kontrakt-forkalkyl>
}

@if (kontrakt.hasAffarsform) {
  <rask-atgard-list></rask-atgard-list>
}

@if ((kontrakt.isAffarsformU4 || kontrakt.isAffarsformU5 || kontrakt.isAffarsformU6) && !kontrakt.isGrot) {
  <rask-skogsvard-list></rask-skogsvard-list>
}

@if (kontrakt.hasAffarsform && !kontrakt.isAvverkning) {
<rask-leveransvirkesplan *raskPermitted="[{ role: 'RASK.Kopplanera', canView: false }]; merge: true">
  </rask-leveransvirkesplan>
}

<rask-kontrakt-certifiering [kontrakt]="entity()"></rask-kontrakt-certifiering>

@if (kontrakt.hasAffarsform && kontrakt.id) {
  <rask-kontrakt-betalning
    *raskPermitted="[{ role: 'RASK.Kopplanera', canView: false }]; merge: true">
  </rask-kontrakt-betalning>
}

@if (kontrakt.hasAffarsform) {
  <rask-kontrakt-nvb></rask-kontrakt-nvb>
}

@if (!kontrakt.isLeveransvirke) {
<rask-kontrakt-anteckningar
    [readonly]="kontraktReadonly">
  </rask-kontrakt-anteckningar>
}
<rask-kontrakt-utskrift
    *raskPermitted="[{ role: 'RASK.Kopplanera', canView: false }]; merge: true">
</rask-kontrakt-utskrift>
<rask-kontrakt-utskrift-dokument></rask-kontrakt-utskrift-dokument>

<rask-kontrakt-bilagor [kontraktId]="kontrakt.id" [readonly]="kontraktReadonly"></rask-kontrakt-bilagor>

<rask-toggle-panel
  helpUrl="https://sveaskog.sharepoint.com/:p:/r/sites/Glantan/SiteCollectionDocuments/Virkesk%C3%B6p/Lathund%20Digital%20Signering.pptx?d=wa0ab0cf6ab1941d6af3e4059eea0e935&csf=1&web=1&e=mXddbV"
  label="Digital signering"
    *raskPermitted="digitalSigneringPermissions">
  <rask-tabs>
    <rask-tab label="Rundvirke/Grot">
            <rask-kontrakt-digitalsignering dokumentTyp="Kontrakt"></rask-kontrakt-digitalsignering>
    </rask-tab>
        @if(enableSignSkogsvardTab$ | async){
      <rask-tab label="Skogsvård">
        <rask-kontrakt-digitalsignering dokumentTyp="SkogsvardsKontrakt"></rask-kontrakt-digitalsignering>
      </rask-tab>
    }
  </rask-tabs>
</rask-toggle-panel>
